import { render } from "./paginationSlider.vue?vue&type=template&id=20d4c50a&scoped=true"
import script from "./paginationSlider.vue?vue&type=script&lang=js"
export * from "./paginationSlider.vue?vue&type=script&lang=js"

import "./paginationSlider.vue?vue&type=style&index=0&id=20d4c50a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20d4c50a"

export default script